import { render } from "./RemediationWidget.vue?vue&type=template&id=6432b048"
import script from "./RemediationWidget.vue?vue&type=script&lang=js"
export * from "./RemediationWidget.vue?vue&type=script&lang=js"

import "./RemediationWidget.vue?vue&type=style&index=0&id=6432b048&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__